<template>
  <div class="char-book">
    <div class="title">范字板书</div>
    <div class="char-display">
      <div  @click="playVideo" class="grid-container">
        <div class="char-grid">
          <img v-if="exampleInfo" :src="exampleInfo.imageUrl" alt="范字示例" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CharBook",
  props: {
    exampleInfo: {
      type: Object,
      default: () => null,
    },
    wordVideoInfo: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {};
  },
  methods: {
    playVideo() {
      if (!this.exampleInfo) {
        return;
      }
      this.$emit("wordPopUp", {
        data: {
          videoInfo: {
            url: this.exampleInfo.videoUrl,
            title: "范字视频",
            poster: this.exampleInfo.imageUrl,
          },
          boardInfo: {
            title: "范字板书",
            poster: this.exampleInfo.imageUrl,
          },
        },
        tab: "board",
      });
    },
  },
};
</script>

<style scoped>
.char-book {
  width: 16.19rem;
  height: 18rem;
  background: #ffffff;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  box-sizing: border-box;
  padding: 0.92rem;
}

.title {
  margin-bottom: 0.36rem;
  font-weight: 600;
  font-size: 1.23rem;
  color: #3d465e;
}

.char-display {
  height: 14.35rem;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  border: 0.46rem solid #ceeeff;
  box-sizing: border-box;
  background: #eeeeee;
}

.grid-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.char-grid {
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.char-grid img {
  cursor: pointer;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 0.46rem 0.46rem 0.46rem 0.46rem;
}
</style>
